import { fetchCurrentUser } from 'auth/services/fetchCurrentUser';
import { retryTracker } from 'tracking/utils/retryTracker';

// NOTE: remove any non alphanumeric values from SKU
const sanitizeSKU = (sku = '') => sku?.replace(/[^\d\sa-z]/gi, '');

/**
 * NOTE: Snapchat seems very particular about the format of their params. Without
 * the keys being in string format trackers do not fire correctly
 **/
export const initializeSnapchatPixel = ({ user, SNAPCHAT_PIXEL_ID }) => {
  return retryTracker({
    callbackFn: () => window?.snaptr('init', SNAPCHAT_PIXEL_ID, { user_email: user?.email }),
    context: 'initializeSnapchatPixel',
    trackerKey: 'snaptr',
  });
};

export const fireSnapchatTracker = (type: string, params = {}) => {
  return retryTracker({
    callbackFn: () => {
      window?.snaptr('track', type, params);
    },
    context: 'fireSnapchatTracker',
    trackerKey: 'snaptr',
  });
};

export const snapchatInitAndFirePageView = ({ isUserAuthenticated, SNAPCHAT_PIXEL_ID }) => {
  return retryTracker({
    callbackFn: async () => {
      let user = { email: '' };
      if (isUserAuthenticated) {
        user = await fetchCurrentUser();
      }
      window?.snaptr('init', SNAPCHAT_PIXEL_ID, { user_email: user?.email });
    },
    context: 'snapchatInitAndFirePageView',
    trackerKey: 'snaptr',
  });
};

export const fireSnapchatAddCart = ({ brandName, productPrice, sku, clientDedupID }) => {
  fireSnapchatTracker('ADD_CART', {
    item_category: brandName,
    item_ids: [sanitizeSKU(sku)],
    price: productPrice * 0.01,
    client_dedup_id: clientDedupID,
  });
};

export const fireSnapchatCheckoutPurchase = ({ brandName, orderNumber, price, sku }) => {
  fireSnapchatTracker('PURCHASE', {
    item_category: brandName,
    item_ids: [sanitizeSKU(sku)],
    price: price * 0.01,
    transaction_id: orderNumber,
  });
};

export const fireSnapchatPageView = (clientDedupID) => {
  return fireSnapchatTracker('PAGE_VIEW', { client_dedup_id: clientDedupID });
};

export const fireSnapchatPDPView = ({ brandName, lowestPriceCents, sku, clientDedupID }) => {
  return fireSnapchatTracker('PAGE_VIEW', {
    price: lowestPriceCents && lowestPriceCents * 0.01,
    item_ids: sku && [sanitizeSKU(sku)],
    item_category: brandName,
    client_dedup_id: clientDedupID,
  });
};

export const fireSnapchatSignUp = (clientDedupID) => {
  fireSnapchatTracker('SIGN_UP', { client_dedup_id: clientDedupID });
};
